import { useEffect, useState } from 'react'
import Mapping from './Mapping'
import CustomBtn from '../../../components/UIBTN/CustomBtn'
import UploadCsv from './UploadCsv'

// icons card
import icLangCard from '../../../assets/svg/steps/card/ic-lang-card.svg'
import icTemplateCard from '../../../assets/svg/steps/card/ic-template-card.svg'
import icCsvCard from '../../../assets/svg/steps/card/ic-csv-card.svg'
import icMappingCard from '../../../assets/svg/steps/card/ic-mapping-card.svg'
import icWhatsappCard from '../../../assets/svg/steps/card/ic-whatsapp-card.svg'

// Icons current Stepper
import icLangStep from '../../../assets/svg/steps/ic-lang.svg'
import icTemplateStep from '../../../assets/svg/steps/ic-template.svg'
import icCsvStep from '../../../assets/svg/steps/ic-csv.svg'
import icMappingStep from '../../../assets/svg/steps/ic-mapping.svg'
import icPhoneStep from '../../../assets/svg/steps/ic-phone.svg'
import icBrodcastStep from '../../../assets/svg/steps/ic-brodcart.svg'

// Icons next Stepper
import icNTemplateStep from '../../../assets/svg/steps/ic-template-a.svg'
import icNCsvStep from '../../../assets/svg/steps/ic-csv-a.svg'
import icNMappingStep from '../../../assets/svg/steps/ic-mapping-a.svg'
import icNPhoneStep from '../../../assets/svg/steps/ic-phone-a.svg'
import icNBrodcastStep from '../../../assets/svg/steps/ic-brodcart-a.svg'

// Icons Done Stepper
import icCheckLangStep from '../../../assets/svg/steps/ic-done/lang.svg'
import icChekTemplateStep from '../../../assets/svg/steps/ic-done/template.svg'
import icChekCsvStep from '../../../assets/svg/steps/ic-done/csv.svg'
import icChekMappingStep from '../../../assets/svg/steps/ic-done/mapping.svg'
import icChekPhoneStep from '../../../assets/svg/steps/ic-done/phone.svg'

import nextBtn from '../../../assets/svg/btn/next-btn.svg'
import icCheck from '../../../assets/svg/icons/ic-check.svg';
import icWarning from '../../../assets/svg/icons/mdi_warning-outline.svg'
import editBtn from '../../../assets/svg/btn/edit.svg';

import RadioContainerTemplate from '../../../components/template/RadioContainerTemplate'
import RadioContainerLang from '../../../components/lang/RadioContainerLang'
import WhatsAppAreaCode from './WhatsAppAreaCode'
import Confirm from './Confirm'
import axiosClient from '../../../../axios-client'
import { ToastContainer, toast } from 'react-toastify'
import { FormControlLabel, FormGroup, Switch } from '@mui/material'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import InfoIcon from '@mui/icons-material/Info';
import { useOutletContext } from 'react-router-dom';
import { Helmet } from 'react-helmet'

const NewBroadcast = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [selectedLangId, setSelectedLangId] = useState(null);
  const [selectedLangName, setSelectedLangName] = useState();
  const [selectedTemplateId, setSelectedTemplateId] = useState();
  const [selectedTemplteName, setSelectedTemplateName] = useState();
  const [csvData, setCSVData] = useState([]);
  const [broadcastName, setBroadcastName] = useState(null);
  const [loading, setLoading] = useState();
  const [idBroadcast, setIdBroadcast] = useState()
  const [csvFile, setCsvFile] = useState(null);
  const [formData, setFormData] = useState({});
  const [mappingData, setMappingData] = useState([]);
  const [selectedPhone, setSelectedPhone] = useState()
  const [selectedflowId, setSelectedflowId] = useState()
  const [selectedCountryId, setSelectedCountryID] = useState()
  const [isSendSucess, setSendSucess] = useState()
  const [isADraf, setAsDraft] = useState()
  const [contactsLeng, setcontactsLeng] = useState()
  const [globalVariablesNames, setglobalVariablesNames] = useState()
  const [dataTotest, setDataTotest] = useState()
  const [dataIsValid, setDataIsValid] = useState()
  const [hasflow, setHasFlow] = useState(false);
  const [formFlow, setFormFlow] = useState(false);
  const [ sendAsForm, setSendAsForm ] = useState(false);
  const { credits, setCredits } = useOutletContext();

  const [ metTitle, setMetaTitle ] = useState('');
  const [ metaDescription, setMetaDescription ] = useState('');

  const notify = ({ msgWarning }) => {
    toast.warning(`${msgWarning}`, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };

  const errNotify = ({ msgErr }) => {
    toast.error(`${msgErr}`, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };


  const handleInputValueChange = (inputValue) => {
    setBroadcastName(inputValue);
  };

  const handleLanguageSelect = (langId, languageName) => {
    setSelectedLangId(langId);
    setSelectedLangName(languageName);
  };

  const handleCsvUpload = (file) => {
    // Process the file data as needed
    setCSVData(file);
    setCsvFile(file);
  };

  const updateFormData = (newData) => {
    setFormData({ ...formData, ...newData });
  };

  const handleReceivedJsonData = (jsonData) => {
    setMappingData(jsonData);
  };


  const validateStepLang = () => {
    if (!selectedLangId || !broadcastName) {
      alert('Please select your language and provide a broadcast name');
      return false;
    } else {
      sendBroadcastName()
    }
  };

  const validateSteTemplate = () => {
    if (!selectedTemplateId) {
      alert('Please select a template');
      return false;
    } else {
      sendTemplateId()
    }
  };

  const sendMapping = () => {
    const resultObject = {
      "data": mappingData
    };

    const jsonString = JSON.stringify(resultObject)


    // console.log(hasflow, sendAsForm, sendAsForm)

    const payload = {
      broadcast_id: idBroadcast,
      data: jsonString,
      global_data: formData,
    };

    if (hasflow && formFlow) {
      if (hasflow && sendAsForm) {
        payload['as_form'] = 'on';
      }
    } else if (!hasflow && formFlow) {
      payload['as_form'] = 'on';
    }

    // console.log('------', hasflow, formFlow);
    console.log(payload);
    // return

    // const result = { data: formData };



    const dataDD = {
      ...mappingData[0],
      ...formData
    }

    setDataTotest(dataDD)
    sendRequest('/broadcast/mapping', payload, () => {

    });
  };

  const sendBroadcast = () => {

    const payload = {
      broadcast_id: idBroadcast,
      country_id: selectedCountryId,
      template_account_flow_id: selectedflowId,
    };

    sendRequest('/broadcast/country', payload, () => {
    });
    userInfo();
  };


  const handleNext = () => {
    const stepValidations = [validateStepLang, validateSteTemplate, validateSteCSVFile, sendMapping, sendBroadcast];

    const currentStepValidation = stepValidations[activeStep];

    if (currentStepValidation()) {

    }
  };

  const sendBroadcastName = () => {
    const payload = {
      language_id: selectedLangId,
      name: broadcastName,
    };

    sendRequest('/broadcasts?', payload, () => {
      // setIdBroadcast(data.data.id);
    });
  };


  const sendTemplateId = () => {
    const payload = {
      broadcast_id: idBroadcast,
      template_id: selectedTemplateId,
    };

    sendRequest('/broadcast/template?', payload, () => {
    });
  };

  const validateSteCSVFile = () => {
    if (!csvFile) {
      notify({ msgWarning: 'Please upload you EXCEL File' });
      return false;
    } else {
      if (!dataIsValid) {
        return;
      }
      submitFile()
    }
  };


  const submitFile = () => {
    setLoading(true);
    var formData = new FormData();
    var csv = document.querySelector('#fileInput');
    formData.append('file', csv.files[0]);
    axiosClient
      .post(`/broadcast/file?broadcast_id=${idBroadcast}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(({ data }) => {
        if (data.success === true) {
          setLoading(false);
          setActiveStep((prevStep) => prevStep + 1);
        }
      })
      .catch((err) => {
        const response = err.response;
        if (response && response.status === 422) {
          errNotify({ msgErr: response.data.message });
        } else if (response && response.status === 404) {
          errNotify({ msgErr: response.data.message });
        }
        setLoading(false);
      });
  };

  const sendRequest = (url, payload, onSuccess) => {
    setLoading(true);

    axiosClient
      .post(url, payload)
      .then(({ data }) => {
        if (data.success === true) {
          if (activeStep == 0) {
            setIdBroadcast(data.data.id);
          }
          setLoading(false);
          setActiveStep((prevStep) => prevStep + 1);
          onSuccess();
        }
      })
      .catch((err) => {
        const response = err.response;
        if (response && response.status === 422) {
          errNotify({ msgErr: response.data.errors });
        } else if (response && response.status === 404) {
          const res = response.data.message
          for (const key in res) {
            if (res.hasOwnProperty(key)) {
              const messages = res[key];
              errNotify({ msgErr: messages });
            }
          }
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    userInfo();
    appSettings();
  }, [])

  const appSettings = () => {
    axiosClient.get('/app-settings')
      .then(({ data }) => {
          setMetaTitle(data.data.title)
          setMetaDescription(data.data.description);
        })
        .catch(() => {
            setLoading(false)
        })
  }

  const userInfo = () => {
    setLoading(true)
    axiosClient.get('/credits')
      .then(({ data }) => {
        setLoading(false)
        setCredits(data.data.credit);
      })
      .catch(() => {
        setLoading(false)
      })
  }

  const handleTemplateClick = (optionId, hasflow, formFlow) => {
    setSelectedTemplateId(optionId);
    console.log(hasflow);
    setHasFlow(hasflow);
    setFormFlow(formFlow);
    setSendAsForm(formFlow)
  };

  const handleSwitchChange = (event) => {
    setSendAsForm(event.target.checked);
    console.log(event)
  };


  const titleStep = [
    <h1 className='text-center title my-3'>Choose the message Language</h1>,
    <h1 className='text-center title my-3'>Choose your Template</h1>,
    <h1 className='text-center title my-3'>Upload your Excel file</h1>,
    <h1 className='text-center title my-3'>Mapping</h1>,
    <h1 className='text-center title my-3'>WhatsApp Area Code</h1>,
  ]


  const steps = [
    <RadioContainerLang onInputValueChange={handleInputValueChange} onClickLang={handleLanguageSelect} />,
    <div className='container-fluid'>
      <RadioContainerTemplate
        isBroadcast={1}
        idBroadcast={1}
        slidToshow={4}
        templateName={(name) => {
          setSelectedTemplateName(name);
        }}
        onClickTemplate={(optionId, hasflow, formFlow) => handleTemplateClick(optionId, hasflow, formFlow)}

        getVariablesNames={(names) => setglobalVariablesNames(names)}

        idTemplate={selectedLangId !== null ? selectedLangId : 3}
      />
      {hasflow && formFlow && (
        <FormGroup>
          <FormControlLabel className='m-auto'
            control={<Switch checked={sendAsForm} onChange={handleSwitchChange} />}
            label={
              <>
                Send as form
                <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip-info'>Choose "Send as form" to send the form version of the template.</Tooltip>}>
                  <InfoIcon className='ms-3' />
                </OverlayTrigger>
              </>
            }
          />
        </FormGroup>
      )}
    </div>,
    //dataTotest
    <UploadCsv getGlobalVariable={globalVariablesNames} onCsvUpload={handleCsvUpload} isValidData={setDataIsValid} />,
    <Mapping contactLengh={(contact) => setcontactsLeng(contact)} onJsonDataReceived={handleReceivedJsonData} idLang={selectedLangId} templateSelected={selectedTemplateId} csvData={csvData} updateFormData={updateFormData} />,
    <WhatsAppAreaCode dataToSend={dataTotest} selectedTemplateId={selectedTemplateId} langId={selectedLangId} getCountryId={(countryId) => setSelectedCountryID(countryId)} getFlowId={(flowId) => setSelectedflowId(flowId)} isForm={formFlow} />,
    <Confirm backStep={() => setActiveStep(4)} getContactLengh={contactsLeng} getBroadcastId={idBroadcast} isDraft={(draft) => setAsDraft(draft)} isDone={(isSuccess) => setSendSucess(isSuccess)} />,
  ];

  const icStep = [
    <img width={52} height={52} className='ic-card mx-auto' src={icLangCard} />,
    <img width={52} height={52} className='ic-card mx-auto' src={icTemplateCard} />,
    <img width={52} height={52} className='ic-card mx-auto' src={icCsvCard} />,
    <img width={52} height={52} className='ic-card mx-auto' src={icMappingCard} />,
    <img width={52} height={52} className='ic-card mx-auto' src={icWhatsappCard} />,

  ]


  return (
    <>
      <Helmet>
          <title>New Broadcast | {metTitle}</title>
          <meta name="description" content={metaDescription}/>
          <meta name="keywords" content="WhatsApp Business, Customer Service, Automations, Broadcasts, AI Chatbots, Lead Qualification" />
      </Helmet>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='container d-flex justify-content-center mx-auto py-3 my-4 pb-5'>
          <div className='bg-white rounded-pill d-flex px-2'>
            <CustomBtn handleClick={!isSendSucess && activeStep !== 0 ? () => setActiveStep(0) : () => { }} className={`${activeStep <= steps.length ? 'active' : ''}`} icon={`${activeStep == 0 ? icLangStep : icCheckLangStep}`} title={'Language'} />
            <span className='divider-step'></span>
            <CustomBtn handleClick={!isSendSucess && activeStep > 1 ? () => setActiveStep(1) : () => { }} className={`${activeStep >= 1 ? 'active' : ''}`} icon={`${activeStep < 1 ? icNTemplateStep : activeStep == 1 ? icTemplateStep : icChekTemplateStep}`} title={'Template'} />
            <span className='divider-step'></span>
            <CustomBtn handleClick={!isSendSucess && activeStep > 2 ? () => setActiveStep(2) : () => { }} className={`${activeStep >= 2 ? 'active' : ''}`} icon={`${activeStep < 2 ? icNCsvStep : activeStep == 2 ? icCsvStep : icChekCsvStep}`} title={'Upload Excel file'} />
            <span className='divider-step'></span>
            <CustomBtn handleClick={!isSendSucess && activeStep > 3 ? () => setActiveStep(2) : () => { }} className={`${activeStep >= 3 ? 'active' : ''}`} icon={`${activeStep < 3 ? icNMappingStep : activeStep == 3 ? icMappingStep : icChekMappingStep}`} title={'Mapping & Information'} />
            <span className='divider-step'></span>
            <CustomBtn handleClick={!isSendSucess && activeStep > 4 ? () => setActiveStep(3) : () => { }} className={`${activeStep >= 4 ? 'active' : ''}`} icon={`${activeStep < 4 ? icNPhoneStep : activeStep == 4 ? icPhoneStep : icChekPhoneStep}`} title={'Area Code & Test Number'} />
            <span className='divider-step'></span>
            <CustomBtn handleClick={() => { }} className={`${activeStep >= 5 ? 'active' : ''}`} icon={`${activeStep < 5 ? icNBrodcastStep : activeStep <= 5 ? icBrodcastStep : icBrodcastStep}`} title={'Broadcast'} />
          </div>
        </div>
      </div>
      <div className='m-0 row justify-content-center align-items-start'>
        <div className='col-md-9 justify-content-center align-items-center p-0'>
          <div className='container pb-5'>
            <div className='row justify-content-center'>
              <div className='col-md-11'>
                <div className='card bg-white border justify-content-center align-items-center'>
                  {icStep[activeStep]}
                  {titleStep[activeStep]}
                  <div className={`${activeStep <= 4 ? 'divider' : ''} my-4`}></div>
                  {steps[activeStep]}
                  <div className='my-4 d-flex justify-content-center align-items-center'>
                    <button
                      variant='none'
                      onClick={!loading ? handleNext : () => { }}
                      disabled={activeStep === steps.length - 1}
                      className={` ${activeStep >= 5 ? 'd-none' : ''} px-1 btn-primary d-flex justify-content-start align-items-center`}>
                      <span>{!loading ? 'Next' : 'Sending...'}</span>
                      <img className='ic-btn' src={nextBtn} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 bg-white p-3 rounded-start justify-content-center">
          <div className='d-flex align-items-end align-items-center'>
            <CustomBtn className={`${activeStep == steps.length ? 'active my-2' : activeStep > 0 ? 'active disabled' : 'active my-2'}`} step={activeStep == 0 ? 1 : <img alt='' src={icCheck} />} icon={`${activeStep == 0 ? icLangStep : icLangStep}`} title={activeStep <= 0 ? 'Language' : `${selectedLangName}`} to={'/new-message'} />
            <span className={`${activeStep <= 0 ? 'd-none' : 'ms-auto p-2'}`} role='button' onClick={!isSendSucess ? () => setActiveStep(0) : () => { }}>
              <img src={editBtn} />
            </span>
          </div>

          <div className='d-flex align-items-end align-items-center'>
            <CustomBtn className={`${activeStep == 1 ? 'active my-2' : activeStep >= 1 ? 'active disabled' : 'my-2'}`} step={activeStep <= 1 ? 2 : <img alt='' src={icCheck} />} icon={`${activeStep < 1 ? icNTemplateStep : icTemplateStep}`} title={activeStep <= 1 ? 'Template' : selectedTemplteName} />
            <span className={`${activeStep <= 1 ? 'd-none' : 'ms-auto p-2'}`} role='button' onClick={!isSendSucess ? () => setActiveStep(1) : () => { }}>
              <img src={editBtn} />
            </span>
          </div>


          <div className='d-flex align-items-end align-items-center'>
            <CustomBtn className={`${activeStep == 2 ? 'active my-2' : activeStep >= 2 ? 'active disabled' : 'my-2'}`} step={activeStep <= 2 ? 3 : <img alt='' src={icCheck} />} icon={`${activeStep < 2 ? icNCsvStep : icCsvStep}`} title={'Upload Excel file'} to={'/new-message'} />
            <span className={`${activeStep <= 2 ? 'd-none' : 'ms-auto p-2'}`} role='button' onClick={!isSendSucess ? () => setActiveStep(2) : () => { }}>
              <img src={editBtn} />
            </span>
          </div>

          <div className='d-flex align-items-end align-items-center'>
            <CustomBtn className={`${activeStep == 3 ? 'active my-2' : activeStep >= 3 ? 'active disabled' : 'my-2'}`} step={activeStep <= 3 ? 4 : <img alt='' src={icCheck} />} icon={`${activeStep < 3 ? icNMappingStep : icMappingStep}`} title={'Mapping & Information'} to={'/new-message'} />
            <span className={`${activeStep <= 3 ? 'd-none' : 'ms-auto p-2'}`} role='button' onClick={!isSendSucess ? () => setActiveStep(3) : () => { }}>
              <img src={editBtn} />
            </span>
          </div>

          <div className='d-flex align-items-end align-items-center'>
            <CustomBtn className={`${activeStep == 4 ? 'active my-2' : activeStep >= 4 ? 'active disabled' : 'my-2'}`} step={activeStep <= 4 ? 5 : <img alt='' src={icCheck} />} icon={`${activeStep < 4 ? icNPhoneStep : icPhoneStep}`} title={'Area Code & Test Number'} to={'/new-message'} />
            <span className={`${activeStep <= 4 ? 'd-none' : 'ms-auto p-2'}`} role='button' onClick={!isSendSucess ? () => setActiveStep(4) : () => { }}>
              <img src={editBtn} />
            </span>
          </div>

          <div className='d-flex align-items-end align-items-center'>
            <CustomBtn className={`${activeStep >= 5 ? 'active my-2' : activeStep >= 5 ? 'active disabled' : 'my-2'}`} step={activeStep <= 5 ? 6 : <img alt='' src={icCheck} />} icon={`${activeStep < 5 ? icNBrodcastStep : icBrodcastStep}`} title={'Broadcast'} to={'/new-message'} />
            <span className={`${activeStep == 4 ? 'd-none' : 'ms-auto p-2'}`} role='button' onClick={!isSendSucess ? () => setActiveStep(5) : () => { }}>
              <img src={isADraf ? icWarning : isSendSucess ? icCheck : ''} />
            </span>
          </div>

        </div>
      </div>
    </>
  )
}


export default NewBroadcast